import React, { ChangeEvent } from "react"
import { customPalette } from "../../../../theme"
import { TextInput } from "./text-input"

export interface IFormTextInputProps {
  fieldName: string
  label: string
  form: Record<string, any>
  errors: Record<string, string | undefined>
  required?: boolean

  handleChange?(event: ChangeEvent<HTMLInputElement>): void
}

export function FormTextInput({
  fieldName,
  label,
  form,
  errors,
  handleChange,
  required = true,
}: Readonly<IFormTextInputProps>): React.JSX.Element {
  return (
    <TextInput
      fieldName={fieldName}
      label={label}
      form={form}
      errors={errors}
      hideBorder
      backgroundColor={customPalette.lightWhite}
      borderRadius={4}
      handleChange={handleChange}
      required={required}
    />
  )
}
